import { TextFieldProps as AriaTextFieldProps } from "react-aria-components";
import { ReactNode } from "react";

export enum MDSTextFieldSlotName {
  LeftAddon = "left",
  RightAddon = "right",
}

export enum MDSTextFieldVariant {
  Default = "default",
  Form = "form",
  Brand = "brand",
  Emphasis = "emphasis",
  Chrome = "chrome",
  Filter = "filter",
}

interface MDSTextFieldBaseProps extends Omit<AriaTextFieldProps, "children"> {
  /**
   * The pointer enter event handler.
   */
  onPointerEnter?: React.HTMLAttributes<HTMLDivElement>["onPointerEnter"];

  /**
   * The pointer leave event handler.
   */
  onPointerLeave?: React.HTMLAttributes<HTMLDivElement>["onPointerLeave"];

  /**
   * The variant of the text field.
   */
  variant?: MDSTextFieldVariant;

  /**
   * The placeholder text to display when the field is empty.
   */
  placeholder?: string;

  /**
   * The error message to display when the field is invalid.
   */
  errorMessage?: string;

  /**
   * The clear text event handler.
   */
  onClearText?: () => void;

  /**
   * Whether to show the clear text button.
   */
  showClearTextButton?: boolean;

  /**
   * The brand click event handler.
   */
  onSubmit?: () => void;

  /**
   * Children to render within the text field.
   */
  children?: ReactNode;
}

export type MDSTextFieldProps =
  | (MDSTextFieldBaseProps & {
      ref?: React.LegacyRef<HTMLInputElement>;
      isTextArea?: false;
      textAreaProps?: never;
      inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
    })
  | (MDSTextFieldBaseProps & {
      ref?: React.LegacyRef<HTMLTextAreaElement>;
      isTextArea: true;
      textAreaProps?: React.TextareaHTMLAttributes<HTMLTextAreaElement>;
      inputProps?: never;
    });
